import { BluxClient } from "../BluxClient";
import { EventRequest } from "../events/types";

// SSoT
export const BRIDGE_PLATFORMS = [
  "none",
  "android",
  "ios",
  "react-native",
  "flutter",
] as const;
export type BridgePlatform = (typeof BRIDGE_PLATFORMS)[number];

export type BridgeAction =
  | "initialize"
  | "signIn"
  | "signOut"
  | "setUserProperties"
  | "setCustomUserProperties"
  | "sendEvent";

const _bridgePayloadMap = {
  initialize: {
    bluxApplicationId: "",
    bluxAPIKey: "",
    customDeviceId: undefined as string | undefined,
  },
  signIn: {} as Parameters<BluxClient["signIn"]>[0],
  signOut: {},
  setUserProperties: {} as Parameters<
    BluxClient["setUserProperties"]
  >[0]["userProperties"],
  setCustomUserProperties: {} as Parameters<
    BluxClient["setCustomUserProperties"]
  >[0]["customUserProperties"],
  sendEvent: { requests: [] as EventRequest[] },
} satisfies Record<BridgeAction, unknown>;

export type BridgePayloadMap = typeof _bridgePayloadMap;

export type BridgePayload = BridgePayloadMap[keyof BridgePayloadMap];

export abstract class Bridge {
  abstract readonly platform: BridgePlatform;

  protected abstract postMessage(
    action: BridgeAction,
    payload?: BridgePayload,
  ): void;

  abstract initialize(payload: BridgePayloadMap["initialize"]): void;

  abstract signIn(payload: BridgePayloadMap["signIn"]): void;

  abstract signOut(): void;

  abstract setUserProperties(
    payload: BridgePayloadMap["setUserProperties"],
  ): void;

  abstract setCustomUserProperties(
    payload: BridgePayloadMap["setCustomUserProperties"],
  ): void;

  abstract sendEvent(payload: BridgePayloadMap["sendEvent"]): void;
}
